<template>
  <div id="points">
    <PointHeader :use="true" />
    <div class="detail">
      <img src="@/static/images/my/jinbi.png" class="bg" />
      <div @click="dateSelect(true)" class="now-date">
        {{ nowDate | nowDateFilter }} <i>▲</i>
      </div>
      <div class="code-box">
        <div>
          <p><span v-show="gainScore != 0">+</span>{{ gainScore }}</p>
          <p>本月入账趣豆</p>
        </div>
        <div>
          <p><span v-show="consumeScore != 0">-</span>{{ consumeScore }}</p>
          <p>本月消耗趣豆</p>
        </div>
      </div>
    </div>

    <ul
      v-infinite-scroll="loadMore"
      infinite-scroll-disabled="loading"
      infinite-scroll-distance="10"
      infinite-scroll-immediate-check="false"
      class="list"
    >
      <li v-for="(item, index) in list" :key="index">
        <div class="code">
          <p>
            <span>{{ item.scoreType == 0 ? "+" : "-" }}</span
            >{{ item.initScore }}
          </p>
        </div>
        <div class="info">
          <p v-show="item.mobile">{{ item.mobileStr }}：{{ item.mobile }}</p>
          <p v-show="item.scoreType == 0">趣豆备注：{{ item.remarks }}</p>
          <p v-show="item.scoreType == 1">消耗项目：{{ item.remarks }}</p>
          <p v-show="item.scoreType == 0">有效期至：{{ item.period }}</p>
          <p v-show="item.scoreType == 0">入账时间：{{ item.createTime }}</p>
          <p v-show="item.scoreType == 1">消耗时间：{{ item.createTime }}</p>
        </div>
      </li>
      <div class="loading" v-show="loading">
        <mt-spinner type="fading-circle"></mt-spinner>
        <p>加载中...</p>
      </div>
      <div class="loading" v-show="loadAll">
        <p>已加载全部</p>
      </div>
    </ul>
    <NoData v-show="noData" />
    <!-- 日期选择器弹出层 -->
    <div id="date-picker" :class="isShowDatePicker ? 'active' : ''">
      <div class="mask" :class="isMask ? 'active' : ''"></div>
      <div class="date-picker-box">
        <div class="ctrl">
          <span @click="dateSelect(false)">取消</span>
          <span @click="dateConfirm">确定</span>
        </div>
        <mt-picker :slots="slots" @change="onValuesChange"></mt-picker>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import PointHeader from "@/components/PointHeader.vue";
export default {
  data() {
    return {
      slots: [
        {
          flex: 1,
          values: [],
          className: "slot1",
          textAlign: "right",
        },
        {
          divider: true,
          content: "-",
          className: "slot2",
        },
        {
          flex: 1,
          values: [
            "01",
            "02",
            "03",
            "04",
            "05",
            "06",
            "07",
            "08",
            "09",
            "10",
            "11",
            "12",
          ],
          className: "slot3",
          textAlign: "left",
        },
      ],
      isShowDatePicker: false,
      isMask: false,
      nowDate: ["2020", "07"],
      willDate: "",
      consumeScore: "", //消耗的趣豆 ,
      gainScore: "", //增加的趣豆 ,
      list: [],
      loading: false,
      loadAll: false,
      noData: false,
      pageNo: "1",
      pageSize: "5",
    };
  },
  created() {
    this.initDate();
  },
  mounted() {
    this.getMyMonthScoreCount();
    this.getMyMonthScoreDetailList();
  },
  components: {
    PointHeader,
  },
  methods: {
    //2.我的月趣豆获取和消费总数
    getMyMonthScoreCount() {
      this.post(this.apis.myMonthScoreCount, {
        memberId: this.userInfo.memberId,
        month: this.nowDate[1],
        year: this.nowDate[0],
      })
        .then((response) => {
          if (response.data.retCode == "SUCCESS") {
            this.consumeScore = response.data.consumeScore;
            this.gainScore = response.data.gainScore;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    loadMore() {
      if (this.loadAll) {
        return;
      }
      this.loading = true;
      this.pageNo++;
      this.getMyMonthScoreDetailList(() => {
        this.loading = false;
      });
    },
    //3.我的月趣豆详情列表
    getMyMonthScoreDetailList(fn) {
      this.post(this.apis.myMonthScoreDetailList, {
        memberId: this.userInfo.memberId,
        month: this.nowDate[1],
        year: this.nowDate[0],
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      })
        .then((response) => {
          if (response.data.retCode == "SUCCESS") {
            this.list = [...this.list, ...response.data.list];
            if (fn) {
              fn();
            }

            if (response.data.list.length == 0 && this.pageNo != 1) {
              this.loadAll = true;
            }
            if (!this.loadAll && response.data.list.length == 0) {
              this.noData = true;
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    initDate() {
      this.slots[0].values = [];
      let year = new Date().getFullYear();
      for (let i = 0; i < 12; i++) {
        this.slots[0].values.push(year);
        year--;
      }
      let month = new Date().getMonth() + 1;
      month = month < 10 ? "0" + month : month;
      this.nowDate[1] = month;
    },
    dateSelect(flag) {
      this.isShowDatePicker = flag;
      setTimeout(() => {
        flag ? (this.isMask = true) : (this.isMask = false);
      }, 500);
    },
    onValuesChange(picker, values) {
      this.willDate = values;
    },
    dateConfirm() {
      this.nowDate = this.willDate;
      this.dateSelect(false);
      this.scrollTop();
      setTimeout(() => {
        this.loading = false;
        this.loadAll = false;
        this.noData = false;
        this.list = [];
        this.pageNo = "1";
        this.pageSize = "5";
        this.getMyMonthScoreCount();
        this.getMyMonthScoreDetailList();
      }, 200);
    },
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  filters: {
    nowDateFilter(val) {
      return val.join("-");
    },
  },
};
</script>

<style lang="less" scoped>
#points {
  .detail {
    height: 210px;
    background-color: #777;
    position: relative;
    .bg {
      width: 195px;
      height: 206px;
      opacity: 0.8;
      position: absolute;
      left: 85px;
      top: 6px;
    }
    .now-date {
      padding-top: 36px;
      padding-bottom: 20px;
      margin: 0 auto;
      width: 160px;
      font-family: PingFang-SC-Regular;
      font-size: 28px;
      color: #fff;
      i {
        display: inline-block;
        font-style: normal;
        font-size: 18px;
        transform: rotate(60deg);
        position: relative;
        top: -6px;
      }
    }
    .code-box {
      display: flex;
      justify-content: space-between;
      > div {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        p {
          font-family: PingFang-SC-Regular;
          font-size: 26px;
          color: #fff;
          &:first-child {
            font-size: 36px;
            font-weight: bold;
            padding-bottom: 10px;
          }
        }
      }
    }
  }
  .list {
    padding: 0 30px;
    li {
      height: 224px;
      border-bottom: 1px solid #c5c5c5;
      display: flex;
      align-items: center;
      .code {
        flex: 0 0 180px;
        line-height: 180px;
        font-weight: bold;
        font-family: PingFang-SC-Bold;
        font-size: 30px;
        color: #4161f0;
        text-align: center;
      }
      .info {
        font-family: PingFang-SC-Regular;
        font-size: 26px;
        line-height: 44px;
        color: #4c4f60;
      }
    }
    .loading-more {
      padding-top: 10px;
      height: 70px;
      border-bottom: none;
    }
    .loading {
      padding-top: 10px;
    }
  }
  #date-picker {
    .mask {
      height: 60%;
      &.active {
        background: rgba(0, 0, 0, 0.6);
      }
    }
    width: 100%;
    height: 100%;
    position: fixed;
    bottom: -2000px;
    z-index: 100;
    transition: bottom 0.52s;
    &.active {
      bottom: 100px;
    }
    .date-picker-box {
      background-color: #fff;
      height: 40%;
      .ctrl {
        display: flex;
        justify-content: space-between;
        border-top: 1px solid #eaeaea;
        border-bottom: 1px solid #eaeaea;
        span {
          padding-left: 30px;
          padding-right: 30px;
          width: 100px;
          height: 56px;
          line-height: 54px;
          font-weight: bold;
          text-align: center;
          color: #26a2ff;
        }
      }
    }
  }
}
</style>
